import { useFindexQuery } from "@/integrations/findex/query";
import type { IProviderImport } from "findef"
import { computed, type Ref } from "vue";

export type UseProviderImports = {
  providerImports: Ref<IProviderImport[]>;
  expiredCount: Ref<number>;
  connectedCount: Ref<number>;
  loading: Ref<boolean>;
  refresh: () => Promise<void>;
  totalCount: Ref<number>;
}

export const useProviderImports = (): UseProviderImports => {
  const refresh = async () => {}

  const findexQuery = useFindexQuery();

  const providerImportQuery = findexQuery.queries.getProviderImports();
  const providerImports = computed(() => providerImportQuery.data.value || []);

  const loading = computed(() => providerImportQuery.isFetching.value);
  const expiredImports = computed(() => loading.value || !Array.isArray(providerImports.value) ? [] : providerImports.value.filter(it => it.session?.connected !== true));
  const expiredCount = computed(() => loading.value ? 0 : expiredImports.value.length);
  const connectedImports = computed(() =>
    loading.value || !Array.isArray(providerImports.value) ? [] : providerImports.value.filter(it => it.session?.connected === true)
  );
  const connectedCount = computed(() => loading.value ? 0 : connectedImports.value.length);
  const totalCount = computed(() => providerImports.value?.length || 0);

  return { refresh, providerImports, expiredCount, connectedCount, loading, totalCount } as UseProviderImports;
}
